import { render, staticRenderFns } from "./GlobalContainerPopup.vue?vue&type=template&id=3a4b3641"
import script from "./GlobalContainerPopup.vue?vue&type=script&lang=js"
export * from "./GlobalContainerPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports